import "./index.css";
import BookCard from './BookCard/BookCard';
import { useEffect } from 'react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {useParams} from "react-router-dom";
import TextLoader from "../../../components/TextLoader/TextLoader";
import { getBookById} from "../../../api/books";

import Dialog from "../create/CreateBookDialog";

export default function BookDetailed(props) {

  const { lang = {} } = props;

  const params = useParams()
  
  const [book, setBook] = useState(null);
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(null);

  const handleClose = () => {
    setCurrent(null)
    setShow(false)
  };

  const handleShow = (book) =>{
    setCurrent(book)
    setShow(true)
  };

  const getBook = async () => {
    const bookId = params.id      
    try {
      const response = await getBookById(bookId);
      const { data } = response;
      const mainAuthor = {'values':data?.authors[0], 'name':data?.collaborators[0]};
      setBook(data);
      setAuthor(mainAuthor);
      setLoading(false);
    } catch (error) {
      // toast.error(lang.book.error.details);
    }
  }

  useEffect(() => {
    getBook();
  }, [])

  const showBookInformation = () => {

    if (loading) {
      return (
        <Row className='justify-content-md-center'>
          <div style={{ paddingTop: '40px' }} />
          <TextLoader
            upperMessage={lang.book.loading.book_upper}
            lowerMessage={lang.book.loading.book_lower}
          />
        </Row>
      )
    };

    return (
      <>
        <Dialog
          show={show} 
          handleClose={handleClose}
          lang={lang}
          current={book}
          onFinish={(resp)=> getBook() }
        />        
        <Row>
          <BookCard
            book={book}
            author={author}
            lang={lang}
            handleShow={()=>handleShow(book)}
          />
        </Row>
        <Row className='mt-2'>
            <div>
                <p>
                    <strong>Características de <span className="text-primary" >{book.title}</span></strong>
                </p>
            </div>
            <Col xs={{span: 12, order:2}} sm={{span: 12, order:2}} md={{span: 6, order:0}} xl={{span: 6, order:0}}>
              <p>
                <span className='titulo-texto'>Facultad</span><br/>
                {book.faculty || 'Humanidades'}<br/>
                <span className='titulo-texto'>Editorial</span><br/>
                {book.editorial || 'No establecido'}<br/>
                <span className='titulo-texto'>Edición</span><br/>
                {book.editionNumber || '1'}<br/>
                <span className='titulo-texto'>Ciudad de publicación</span><br/>
                {book.publicationCity || 'No establecido'}<br/>
                <span className='titulo-texto'>País de publicación</span><br/>
                {book.publicationCountry || 'No establecido'}<br/>
                <span className='titulo-texto'>Páginas</span><br/>
                {book.pages || 'No establecido'}<br/>
                <span className='titulo-texto'>ISBN-13</span><br/>
                {book.isbn13 || 'No establecido'}<br/>
                <span className='titulo-texto'>DOI</span><br/>
                {book.doi || 'No establecido'}<br/>
                <span className='titulo-texto'>Año</span><br/>
                {book.editionYear || 'No establecido'}<br/>
                <span className='titulo-texto'>Dimensiones</span><br/>
                {book.physicalDimentions || 'No establecido'}<br/>
                <span className='titulo-texto'>BISAC</span><br/>
                {book.bisac || 'Humanidades'}<br/>
            

              </p>
            </Col>
            <Col xs={{span: 12, order:2}} sm={{span: 12, order:2}} md={{span: 6, order:0}} xl={{span: 6, order:0}}>
              <p>
                <span className='titulo-texto'>Formato</span><br/>
                {book.fileFormat || 'Impreso'}<br/>
                <span className='titulo-texto'>Detalles del formato</span><br/>
                {book.formatDetails || 'No establecido'}<br/>
                <span className='titulo-texto'>Ilustrado</span><br/>
                {book.hasIlustrations || 'No'}<br/>
                <span className='titulo-texto'>SKU</span><br/>
                {book.bwSKU || 'No establecido'}<br/>
                <span className='titulo-texto'>Personalizado</span><br/>
                {book.customized || 'No'}<br/>
                <span className='titulo-texto'>Idioma</span><br/>
                {book.language || 'Español'}<br/>

                <span className='titulo-texto'>Derechos</span><br/>
                {book.sellingRights || 'Copyright-DRA'}<br/>
                <span className='titulo-texto'>Peso</span><br/>
                {book.weight || 'No establecido'}<br/>

                <span className='titulo-texto'>Público objetivo</span><br/>
                {book.audience || 'General'}<br/>
              </p>
            </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      {showBookInformation()}
    </>
  )
}